import React, { useState, useEffect, useRef } from "react";
import { TextField, Button, CircularProgress } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Http from "../Http";

export default function BuscarGuia({
  onSelect,
  estado = [1],
  circuito = null,
  condiciones = true,
  textoBoton = false,
}) {
  const buttonRef = useRef();
  const [open, setOpen] = useState(false);
  const [folio, setFolio] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("typing")
  const [folioSeleccionado, setFolioSeleccionado] = useState(null);
  const [opciones, setOpciones] = useState([]);
  let scannedFolio = "";

  const keyDown = (e) => {
    if (e.keyCode === 13 && scannedFolio.length > 0) {
      folioChange(null, scannedFolio, 'scan');
      scannedFolio = "";
    } else {
      if (!isNaN(e.key)) {
        scannedFolio = `${scannedFolio}${e.key}`;
      }
    }
  };

  useEffect(() => {
    if (mode === "scanning") {
      window.addEventListener("keydown", keyDown);
    } else {
      window.removeEventListener("keydown", keyDown);
    }
    return () => {
      window.removeEventListener("keydown", keyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const folioChange = async (text, id_guia, reason) => {
    const value = text ? text : (id_guia || '');
    if (reason && (reason !== 'reset' || (reason === 'reset' && ![null, ''].includes(value)))) {
      setFolio(value);
    }
    let strQuery = ``;
    if (circuito) {
      strQuery = strQuery + `&id_circuito=${circuito}`;
    }
    if (id_guia) {
      strQuery = strQuery + `&id_guia=${id_guia}`;
    }
    if (condiciones) {
      strQuery = strQuery + `&condiciones=${condiciones}`;
    }
    if (value.length > 2 && ['input', 'scan'].includes(reason) ) {
      try {
        if (loading) {return;}
        setLoading(true);
        let Res = await Http.get(`guia/buscar?folio=${value}&estado=${estado}${strQuery}`);
        // opciones = Res.data;
        if (mode === "typing") {
          setOpciones(Res.data);
        } else if (mode === "scanning" && Res.data && Res.data.length > 0) {
          setOpciones([]);
          onSelect(Res.data[0]);
        }
        // Vaciar en options y seguir con el proceso
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const folioSelecChange = (event, value) => {
    setFolioSeleccionado(value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    // console.log(folioSeleccionado)
    if (folioSeleccionado) {
      onSelect(folioSeleccionado);
    }
  };

  const changeMode = () => {
    buttonRef.current.blur();
    setMode(mode === "typing" ? "scanning" : "typing",);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div>
        <Button variant="text" color="primary" onClick={changeMode} ref={buttonRef} >
          Cambiar a modo
          {mode === "typing" ? " Scaneo Codigo de Barras" : " Busqueda Manual"}
        </Button>
      </div>
      {mode === "typing" ? (
        <form
          onSubmit={onSubmit}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Autocomplete
            open={open}
            onOpen={() => { setOpen(true); }}
            onClose={() => { setOpen(false); }}

            value={folioSeleccionado}
            onChange={folioSelecChange}
            getOptionLabel={(option) => option.label}

            inputValue={folio}
            onInputChange={(e, value, reason) => { folioChange(value, false, reason) }}

            style={{ width: 330 }}
            options={opciones}
            loading={loading}
            placeholder={"Buscar por folio"}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus={true}
                label="Buscar Guia"
                variant="outlined"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
          <div style={{ margin: 10 }}>
            <Button variant="contained" color="primary" type="submit">
              {textoBoton || 'Agregar'}
            </Button>
          </div>
        </form>
      ) : (
        <div> {folio ? `Folio: ${folio}` : "Esperando Lectura"} </div>
      )}
    </div>
  );
}
